import React from "react";
import { ColumnValueRendererProps } from "../table.data.interface";

const TextColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  // In preview mode, use text property from Monday.com API
  if (isPreview) {
    return <div className="text-sm text-gray-700">{columnData?.text || ""}</div>;
  }

  if (columnData?.value === "Empty Column" || (!columnData?.value && otherBoardsValues)) {
    return null;
  }

  return <div>{columnData?.value as string}</div>;
};

export default TextColumn;
